import { useNavigate } from 'react-router-dom'
import { useFormik } from 'formik'
import { requestPassword } from '../core/_requests'
import { AuthTrustFooter, Button, FormInput, LoadingIndicator } from '../../../components'
import { forgotPasswordSchema } from './validation/forgotPasswordSchema'
import { ButtonType, showError } from '../../../../_metronic/helpers'
import { PasswordDtoRecover } from '../core/_models'
import { useT } from '_metronic/i18n/Metronici18n'

export const ForgotPassword = () => {
  const navigate = useNavigate()
  const { t } = useT()

  const initialValues = {
    email: '',
  }

  const formik = useFormik({
    initialValues,
    validationSchema: forgotPasswordSchema,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      setSubmitting(true)
      try {
        const data: PasswordDtoRecover = {
          email: values.email,
        }
        const response = await requestPassword(data)
        setStatus(response.message ?? 'Um e-mail foi enviado para a recuperação da sua senha.')
      } catch (error) {
        showError(error)
      } finally {
        setSubmitting(false)
      }
    },
  })

  return (
    <form noValidate autoComplete='off' onSubmit={formik.handleSubmit}>
      <div className='text-start mb-10'>
        <h1 className='text-dark mb-3 fs-2x'>Esqueceu sua senha?</h1>
        <div className='text-gray-700 fw-semibold fs-3'>Informe seu e-mail para recuperá-la.</div>
      </div>
      {formik.status && <div className='alert alert-success'>{formik.status}</div>}
      <FormInput
        formik={formik}
        name='email'
        label='E-mail'
        placeholder='Digite seu e-mail'
        isRequired
        className='mb-5'
        autoComplete='off'
      />
      <div className='d-flex flex-column gap-3'>
        <Button
          type={ButtonType.Submit}
          className='btn-primary btn-auth-full'
          disabled={formik.isSubmitting}
        >
          {formik.isSubmitting ? <LoadingIndicator /> : t('common.send')}
        </Button>
        <Button
          onClick={() => navigate('/auth/login')}
          className='btn-secondary btn-auth-full'
          disabled={formik.isSubmitting}
        >
          {t('common.cancel')}
        </Button>
      </div>
      <AuthTrustFooter />
    </form>
  )
}
